<script setup>
import { reactive, toRaw } from 'vue';
import { ElForm, ElSwitch, ElFormItem, ElSelect, ElOption, ElButton, ElDivider, ElColorPicker } from 'element-plus';
import { useSettingsStore } from '../stores/fpe-settings'
import { storeToRefs } from 'pinia'

const store = useSettingsStore();
const { isUpdating, settings } = storeToRefs(store);

const form = reactive( settings.value );
const tabs = fpe.tabs;
const trigger_options = fpe.trigger_options;
const all_roles = fpe.all_roles;
const product_types = fpe.product_types

const { editor_positions } = fpe;

const colorChange = (color) => {
    form.editor_color = color;
}

</script>

<template>
    <ElForm :model="form" class="wpv-fpe-form" label-width="250px" label-position="left">
        <ElFormItem label="Tabs Collapsed by default">
            <ElSwitch v-model="form.tabs_collapsed" />
        </ElFormItem>

        <ElFormItem label="Default Tab">
            <ElSelect v-model="form.default_tab">
                <el-option
                    v-for="( item, index ) in tabs"
                    :key="index"
                    :label="item"
                    :value="index"
                />
            </ElSelect>
        </ElFormItem>

        <ElFormItem label="Trigger Options">
            <ElSelect v-model="form.trigger_option">
                <el-option
                    v-for="( item, index ) in trigger_options"
                    :key="index"
                    :label="item"
                    :value="index"
                />
            </ElSelect>
        </ElFormItem>
        
        <ElFormItem label="Allowed User Roles">
            <ElSelect v-model="form.allowed_user_roles" multiple>
                <el-option
                    v-for="( item, index ) in all_roles"
                    :key="index"
                    :label="item"
                    :value="index"
                />
            </ElSelect>    
        </ElFormItem>

        <ElFormItem label="Edit from Archives">
            <ElSwitch v-model="form.edit_from_archive" />
        </ElFormItem>

        <ElFormItem label="Product Types">
            <ElSelect v-model="form.allowed_product_types" multiple>
                <el-option
                    v-for="( item, index ) in product_types"
                    :key="index"
                    :label="item.label"
                    :value="index"
                    :disabled="item.disabled"
                />
            </ElSelect>
        </ElFormItem>

        
        <ElFormItem label="Editor Position">
            <ElSelect v-model="form.editor_position">
                <el-option
                    v-for="( item, index ) in editor_positions"
                    :key="index"
                    :label="item"
                    :value="index"
                />
            </ElSelect>
        </ElFormItem>  
         
        <ElFormItem label="Editor Color">
            <ElColorPicker v-model="form.editor_color" @active-change="colorChange" />
        </ElFormItem>

        <ElFormItem>
            <el-button :loading="isUpdating" type="primary" @click="store.updateSettings(toRaw(form))">Save Settings</el-button>
        </ElFormItem>

    </ElForm>
</template>